;(function(){
	var $pkg = $('.js-packaging');

	if (!$pkg.length) return false;

	$pkg = {
		root: $pkg,
		nav: {
			wrapper: $pkg.find('.js-packaging__nav-wrapper'),
			main: $pkg.find('.js-packaging__nav'),
			links: $pkg.find('.js-packaging__nav-link'),
		},
		packages: $pkg.find('.js-packaging__section'),
		images: $pkg.find('.js-package__image'),
	};
	var $siteHeader = $('.site-header');

	var settings = {
		breakpoint: 768,
		active: false,
	};
	var timeout;

	var pkg = {
		init: function() {
			site.resize.after['packaging'] = pkg.onResize;
			pkg.onResize();

			window.addEventListener('scroll', function() {
				if (timeout) window.cancelAnimationFrame(timeout);

				timeout = window.requestAnimationFrame(function() {
					pkg.onScroll();
				});
			}, false);

			$pkg.images.cleverScroll({
				offset: site.height / 8,
				onEnterViewport: function($el) {
					$el.attr('src', $el.data('animation'));
				},
			});
		},

		onResize: function() {
			settings.active = site.width >= settings.breakpoint;

			if (!settings.active) return;

			settings.fixedTopPos = $siteHeader.height();
			settings.fixedLeftPos = $pkg.nav.wrapper.offset().left;

			// section top positions
			settings.packagePositions = {};
			$pkg.packages.each(function() {
				var $el = $(this);
				settings.packagePositions[$el.attr('id')] = $el.offset().top;
			});

			// fix at
			// at what point does the nav become fixed
			var offset = $pkg.root.offset().top;
			var headerHeight = $siteHeader.height();
			settings.fixAt = offset - headerHeight;

			// max scroll
			// at which point the nav sticks to the bottom of the screen and scrolls away
			var navWrapperHeight = $pkg.nav.wrapper.height();
			var navHeight = $pkg.nav.main.outerHeight();

			settings.maxScroll = (offset + navWrapperHeight) - headerHeight - navHeight;

			pkg.onScroll();
		},

		onScroll: function() {
			if (!settings.active) return;

			var isFixed = site.scroll.y >= settings.fixAt && site.scroll.y < settings.maxScroll;
			var reachedMaxScroll = site.scroll.y >= settings.maxScroll;

			$pkg.nav.main.toggleClass('is-fixed', isFixed);
			$pkg.nav.main.css('top', isFixed ? settings.fixedTopPos : 0);
			$pkg.nav.main.css('left', isFixed ? settings.fixedLeftPos : 0);

			$pkg.nav.main.toggleClass('max-scroll', reachedMaxScroll);

			var activeID = null;
			$.each(settings.packagePositions, function(i, v) {
				if (site.scroll.y + site.height >= v) activeID = i;
			});

			pkg.updateNav(activeID);
		},

		updateNav: function(id) {
			$pkg.nav.links.filter('.is-active').removeClass('is-active');

			$pkg.nav.links.filter('[ref=' + id + ']').addClass('is-active');
		},
	};

	pkg.init();
}());
